import { createContext, useContext } from "react";

export type AppContextData = {};
export const AppContext = createContext<AppContextData | undefined>(undefined);

export function useAppContext(): AppContextData {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppContextProvider");
  }
  return context;
}
